<template>
  <Transition name="toast" appear :duration="{ enter: 300, leave: 240 }" @after-leave="onAfterLeave">
    <div
      v-if="visible"
      class="toast-notification"
      role="status"
      aria-live="polite"
    >
      {{ message }}
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';

const props = withDefaults(defineProps<{
  message: string;
  duration?: number;
}>(), {
  duration: 1900,
});

const emit = defineEmits<{
  (e: 'dismiss'): void;
}>();

const visible = ref(true);
let timer: ReturnType<typeof setTimeout> | null = null;

onMounted(() => {
  timer = setTimeout(() => {
    visible.value = false;
  }, props.duration);
});

onBeforeUnmount(() => {
  if (timer !== null) {
    clearTimeout(timer);
  }
});

const onAfterLeave = () => emit('dismiss');
</script>

<style lang="scss" scoped>
.toast-notification {
  background: var(--Colors-Background-bg-primary-solid);
  color: var(--Colors-Text-text-white);
  font-family: var(--Fontfamilyfont-family-body);
  font-size: var(--Fontsizetext-xs);
  line-height: var(--Lineheighttext-xs);
  font-weight: 600;
  text-align: center;
  padding: rem-calc(8) rem-calc(12);
  border-radius: rem-calc(8);
  box-shadow:
    0 2px 2px -1px var(--ColorsEffectsShadowsshadow-lg03),
    0 4px 6px -2px var(--ColorsEffectsShadowsshadow-lg02),
    0 12px 16px -4px var(--ColorsEffectsShadowsshadow-lg01);
  white-space: nowrap;
  pointer-events: none;
  left: 50%;
  transform: translateX(-50%);

  @include breakpoint(small) {
    position: fixed;
    top: rem-calc(60);
    z-index: 1000;
  }
}

.toast-enter-active {
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.toast-leave-active {
  transition: transform 0.24s cubic-bezier(0.36, 0, 0.66, -0.56);
}

.toast-enter-from,
.toast-leave-to {
  transform: translate(-50%, -200%);
}
</style>
